import { Component } from '@angular/core';

@Component({
  selector: 'app-contract-master',
  templateUrl: './contract-master.component.html',
  styleUrls: ['./contract-master.component.css']
})

export class ContractMasterComponent  {
  constructor() { }
}
